// extracted by mini-css-extract-plugin
export default {"selector":"AppCountryRegion_selector__eP5UT"};